import gql from "graphql-tag";

export const MY_TAX_GET_DECLARATIONS_LIST = gql`
  query taxDeclarationList($page: Int, $pageSize: Int, $type: String) {
    taxDeclarationList(page: $page, pageSize: $pageSize, type: $type) {
      rows {
        tableId
        year
        createdAt
        state
        isModifiedDeclaration
        type
        _id
      }
      page
      pageSize
      total
      totalPages
    }
  }
`;
